import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class BookBadge extends WritingBadge {
  public readonly id = BadgeId.book;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.wordsCount >= 10000;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/book.ts